import * as React from 'react'

import { useTimelineData } from '../context/DataContext'
import { WeekRecompenseBlock } from '../blocks/WeekRecompenseBlock'
import { LayerWrapper } from './LayerWrapper'
import { LayerProps } from './types'

const WeekRecompensesLayer: React.FC<LayerProps> = ({ zIndex }) => {
  const { weekRecompenses } = useTimelineData()

  return (
    <LayerWrapper zIndex={zIndex}>
      {weekRecompenses.map((item, index) => (
        <WeekRecompenseBlock key={index} weekRecompense={item} index={index} />
      ))}
    </LayerWrapper>
  )
}

export default WeekRecompensesLayer
